export const NEW_DOCUMENT = "v2/documents";
export const MY_DOCUMENTS = "v2/documents";
export const GET_DOCUMENT = "v2/documents/fetch/";
export const DOCUMENTS_SENT = "v2/documents/sent";
export const CANCEL_PROCESS = "v2/documents/cancel";
export const ARCHIVE = "v2/documents/archive";
export const MARK_AS_READ = "v2/documents/mark-as-read";
export const UPDATE_SEND_TO = "v2/documents/send-to";
export const CONSUMPTION = "v2/documents/consumption";